<template>
    <transition name="el-zoom-in-top">
    <div class="transition-box" v-show="showDiv">
        <div >
            <el-carousel indicator-position="outside">
                <el-carousel-item v-for="item in imgList" :key="item">
                    <el-image :src="item"></el-image>
                </el-carousel-item>
            </el-carousel>

        </div>
        <el-form ref="elForm" :model="formData" :rules="rules" size="medium" label-width="100px"
                 label-position="left">
            <el-row type="flex" justify="center" align="top">
                <el-col :span="10">
                    <el-form-item label="" prop="field117" style="margin-right: 100px;margin-top: 10px">
                        <el-button type="primary" icon="el-icon-s-order" size="medium" @click="goTeam"> 团体登记 </el-button>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" align="top">
                <el-col :span="10">
                    <el-form-item label="" prop="field119" style="margin-right: 100px;margin-top: 10px">
                        <el-button type="primary" icon="el-icon-user-solid" size="medium" @click="goPerson"> 个人登记 </el-button>
                    </el-form-item>
                </el-col>
            </el-row>
           <!-- <el-row type="flex" justify="center" align="top">
                <el-col :span="10">
                    <el-form-item label="" prop="field121" style="margin-right: 100px;margin-top: 10px">
                        <el-button type="primary" icon="el-icon-search" size="medium"> 团体查询 </el-button>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" align="top">
                <el-col :span="10">
                    <el-form-item label="" prop="field123" style="margin-right: 100px;margin-top: 10px">
                        <el-button type="primary" icon="el-icon-search" size="medium"> 个人查询 </el-button>
                    </el-form-item>
                </el-col>
            </el-row>-->
           <!-- <el-form-item size="large">
                <el-button type="primary" @click="submitForm">提交</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>-->
        </el-form>

    </div>
    </transition>
</template>
<script>
    import { getAction, postAction,httpAction } from '../../api/manage';
    import preventReClick from '../../utils/preventReClick';
    export default {
        components: {},
        props: [],
        data() {
            return {
                formData: {
                    title: "",
                    orgUser: "",
                    type: "机构",
                    field119: null,
                    field120: null,
                    field122: null,
                    field125: null,
                    phone: "",
                    captcha: "",
                    file1:null,
                    file2:null,
                    file3:null,
                    file4:null

                },

                showDiv:false,
                showLoad:false,
                qrVisible:false,
                smsTime:0,
                unSend:true,
                isPhone:false,
                phoneMessage:"",
                smsTxt:"发送验证码",

                rules: {
                    title: [{
                        required: true,
                        message: '请输入团体名称',
                        trigger: 'blur'
                    }],
                    orgUser: [{
                        required: true,
                        message: '请输入领队姓名',
                        trigger: 'blur'
                    }],
                    type: [{
                        required: true,
                        message: '团体性质不能为空',
                        trigger: 'change'
                    }],
                    phone: [{
                        required: true,
                        message: '请输入领队手机号',
                        trigger: 'blur'
                    }],
                    captcha: [{
                        required: true,
                        message: '请输入短信验证码',
                        trigger: 'blur'
                    }],
                },
                file1List: [],
                file2List: [],
                file3List: [],
                file4List: [],
                typeOptions: [{
                    "label": "机构",
                    "value": "机构"
                }, {
                    "label": "学校",
                    "value": "学校"
                }],
                imgList:[
                    "http://www.hotplutus.cn/pic/1.jpg"
                ]
            }
        },
        computed: {},
        watch: {},
        created() {
            /////验证码计时
            this.smsTime =   window.localStorage.getItem("smsTime");
            if(this.smsTime!=null&&this.smsTime!=0&&typeof(this.smsTime)!="undefined"){
                this.unSend=false;
                let timer = setInterval(() => {
                    this.smsTime--
                    window.localStorage.setItem("smsTime",this.smsTime);
                    if (this.smsTime === 0) {
                        clearInterval(timer)
                        this.unSend = true;
                    }
                }, 1000);
            }
        },
        mounted() {this.showDiv=true;},
        methods: {
            goTeam(){
                this.$router.push({
                    name: 'team',
                    query:{t:Date.now()}
                });

            },
            goPerson(){
                this.$router.push({
                    name: 'person',
                    query:{t:Date.now()}
                });

            }

        }
    }

</script>
<style>
    .transition-box {
    }
    .el-carousel__item h3 {
        color: #475669;
        font-size: 18px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }
</style>




// WEBPACK FOOTER //
// src/views/home/index.vue